export class GcpBigQueryResource {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "datasetId",
            "baseName": "datasetId",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "description",
            "baseName": "description",
            "type": "string",
            "format": ""
        },
        {
            "name": "labels",
            "baseName": "labels",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "defaultTableExpirationMs",
            "baseName": "defaultTableExpirationMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "defaultPartitionExpirationMs",
            "baseName": "defaultPartitionExpirationMs",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "creationTime",
            "baseName": "creationTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastModifiedTime",
            "baseName": "lastModifiedTime",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "storageBillingModel",
            "baseName": "storageBillingModel",
            "type": "string",
            "format": ""
        },
        {
            "name": "totalLogicalBytes",
            "baseName": "totalLogicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "totalPhysicalBytes",
            "baseName": "totalPhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "activeLogicalBytes",
            "baseName": "activeLogicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "longTermLogicalBytes",
            "baseName": "longTermLogicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "activePhysicalBytes",
            "baseName": "activePhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "longTermPhysicalBytes",
            "baseName": "longTermPhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "timeTravelPhysicalBytes",
            "baseName": "timeTravelPhysicalBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "timeTravelWindowDays",
            "baseName": "timeTravelWindowDays",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "cmekKeyName",
            "baseName": "cmekKeyName",
            "type": "string",
            "format": ""
        },
        {
            "name": "tableCount",
            "baseName": "tableCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "viewCount",
            "baseName": "viewCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "materializedViewCount",
            "baseName": "materializedViewCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "routineCount",
            "baseName": "routineCount",
            "type": "number",
            "format": "int32"
        },
        {
            "name": "tables",
            "baseName": "tables",
            "type": "Array<GcpBigQueryResourceTablesInner>",
            "format": ""
        },
        {
            "name": "views",
            "baseName": "views",
            "type": "Array<GcpBigQueryResourceViewsInner>",
            "format": ""
        },
        {
            "name": "materializedViews",
            "baseName": "materializedViews",
            "type": "Array<GcpBigQueryResourceMaterializedViewsInner>",
            "format": ""
        },
        {
            "name": "routines",
            "baseName": "routines",
            "type": "Array<GcpBigQueryResourceRoutinesInner>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GcpBigQueryResource.attributeTypeMap;
    }
    constructor() {
    }
}
